import Cookies from '../import/cookies'

export const Device = {
    TABLET: 'tablet',
    SMARTPHONE: 'smartphone',
    DESKTOP: 'desktop',
};

export const isDesktop = (win = window) => win.innerWidth > 1024 && Cookies.get('touched') === null;

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (typeof parts !== 'undefined' && parts.length === 2) {
        return parts.pop()!.split(';').shift();
    }
};

export function isTablet() {
    const wasTouchedBefore = getCookie("touched") !== undefined;
    return window.innerWidth <= 1024 || wasTouchedBefore;
};

export const getDeviceType = (win = window) => {
    if (!isDesktop(win)) {
        if (win.innerWidth > win.innerHeight) {
            return win.innerWidth >= 960 ? Device.TABLET : Device.SMARTPHONE;
        }
        return win.innerWidth >= 768 ? Device.TABLET : Device.SMARTPHONE;
    }
    return Device.DESKTOP;
};

export const isOpenInEditor = (): boolean => {
    return window.self !== window.top
}
